import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject, map } from 'rxjs';
import {
  clearProductList,
  getProductList,
  setProductList,
  setProductListFacetApplied,
  setSpecificProductOnList,
} from '@b2b/features/product/core/store/actions/product-list.actions';
import { selectProductList } from '@b2b/features/product/core/store/selectors/product-list.selectors';
import { Facet, PLPParams } from '@b2b/features/product/core/utilities/product-list.model';
import { Product } from '@b2b/features/product/core/utilities/product.model';

@Injectable({
  providedIn: 'root',
})
export class ProductListService {
  constructor(private store: Store) {}

  gridOption$ = new BehaviorSubject('grid');

  clear() {
    this.store.dispatch(clearProductList());
  }

  get() {
    return this.store.select(selectProductList);
  }

  setSpecificProduct(product: Product, index: number) {
    this.store.dispatch(setSpecificProductOnList({ product, index }));
  }
  setProductList(products: Product[]) {
    this.store.dispatch(setProductList({ products }));
  }

  take() {
    return this.store.select(selectProductList).pipe(
      map(res => {
        if (!res.products?.data?.products) return [];
        return res.products.data.products;
      }),
    );
  }

  load(params: PLPParams) {
    this.store.dispatch(getProductList({ params }));
  }

  setFacetsApplied(appliedFacets: Facet[]) {
    this.store.dispatch(setProductListFacetApplied({ appliedFacets }));
  }
}
